import { render, staticRenderFns } from "./FourGroup.vue?vue&type=template&id=78724956&scoped=true&"
import script from "./FourGroup.vue?vue&type=script&lang=js&"
export * from "./FourGroup.vue?vue&type=script&lang=js&"
import style0 from "./FourGroup.vue?vue&type=style&index=0&id=78724956&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78724956",
  null
  
)

export default component.exports